
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import DeliveryBanner from '@/components/banners/DeliveryBanner';
import MobileMenu from '@/components/header/MobileMenu';

import { TopBanner } from '@/components/header/TopBanner';
import { DesktopHeader } from '@/components/header/DesktopHeader';
import { MobileHeaderContent } from '@/components/header/MobileHeaderContent';
import { useCategoryNavigation } from './CategoryNavigation';

interface HeaderContainerProps {
  onSearch: (searchTerm: string) => void;
}

const HeaderContainer = ({ onSearch }: HeaderContainerProps) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const { navCategories } = useCategoryNavigation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  return (
    <>
      <DeliveryBanner />
      <header 
        className={`sticky top-[32px] z-50 w-full transition-all duration-300 ${
          isScrolled ? 'bg-white shadow-md py-4' : 'bg-cream-50 py-4'
        }`}
      >
        <TopBanner />

        <div className="container-custom">
          <DesktopHeader onSearch={onSearch} />
          <MobileHeaderContent onSearch={onSearch} onMenuOpen={() => setIsMenuOpen(true)} />
        </div>
      </header>

      <MobileMenu 
        isOpen={isMenuOpen}
        onClose={() => setIsMenuOpen(false)}
        categories={navCategories}
      />
    </>
  );
};

export default HeaderContainer;
